import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import SignedInLink from './SignedInLink'
import SignedOutLink from './SignedOutLink'
import { Yoga } from 'grommet-icons';


/* So - you can use <NavItem> if you want, but that only supports static links
 * If you want to integrate with the router you'll want to use NavItem instead
 * To get the nice styling we put each of these in <li>tags</li>
 */
const YogaNav = (props) => {
  const loggedIn = props.auth.uid ? true : false

  const loginLinks = loggedIn ? <SignedInLink /> : <SignedOutLink />

  return (
    <React.Fragment>
      <nav>
        <div className="nav-wrapper #e57373 red lighten-2">
        <a href="/" data-target="mobile-nav" className="sidenav-trigger"><i className="material-icons">menu</i></a>
          <div className="brand-logo"><Yoga color='white' size='medium' /><Link to='/'>Yoga Dice</Link></div>
            <ul id="nav-mobile" className="right hide-on-med-and-down">
              { loginLinks }
            </ul>
          </div>
      </nav>

    <ul className="sidenav" id="mobile-nav">
      { loginLinks }
    </ul>
  </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth
  }
}

export default connect(mapStateToProps)(YogaNav)